import { render, staticRenderFns } from "./o-product-guided-checkout.vue?vue&type=template&id=04f18bc8&scoped=true&"
import script from "./o-product-guided-checkout.vue?vue&type=script&lang=js&"
export * from "./o-product-guided-checkout.vue?vue&type=script&lang=js&"
import style0 from "./o-product-guided-checkout.vue?vue&type=style&index=0&id=04f18bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f18bc8",
  null
  
)

export default component.exports